<template>
    <div>
        <div class="mb-3 flex gap-4">
            <hts-form-button
                color="info"
                :disabled="!itemSelected.length"
                icon-name="hi-check-circle-icon"
                icon-position="right"
                type="button"
                @click="handleAction('approve')">
                {{ $t('labels.confirm') }}
            </hts-form-button>

            <hts-form-button
                :disabled="!itemSelected.length"
                color="error"
                icon-name="hi-minus-circle-icon"
                icon-position="right"
                type="button"
                @click="showPopupReject = true">
                {{ $t('labels.reject') }}
            </hts-form-button>
        </div>
        <hts-data-table
            ref="dataTables"
            :headers="headers"
            :server="servers"
            use-selection
            :is-row-selectable="isRowSelectable"
            :pagination-page-size="100"
            store-name="tripDataTable"
            store-key="Trip"
            @selection-changed="onSelectionChanged" />

        <hts-modal
            :show="showPopupReject"
            title="Từ chối"
            type="confirm"
            content="Sau khi từ chối, bạn sẽ không thể thực hiện các thao tác khác trên chặng hàng. Bạn có muốn tiếp tục từ chối?"
            @hide="showPopupReject = false"
            @confirm="handleAction('reject')" />
    </div>
</template>
<script lang="ts" setup>
import { $api, $lodash, $urlPartner } from '#imports'

const store = $store()
const user = store.userConfig.getUser

const route = useRoute()
const allocationCode = computed(() => route.params.allocationcode)
const transportation = computed(() => route.query.transportation)
const dataTables = ref()

const { $formatters } = useNuxtApp()

const trips = ref<any[]>([])
const isRowSelectable = ref<any>(null)
const itemSelected = ref<any[]>([])
const showPopupReject = ref(false)

onBeforeMount(() => {
  isRowSelectable.value = (params: any) => {
    return params.data.status === 1
  }
})

const servers = computed(() => {
  return {
    method: 'post',
    url: `/partner/trip/journey/allocation/${allocationCode.value}`
  }
})

const onSelectionChanged = (data: any) => {
  itemSelected.value = Array.isArray(data?.value) ? $lodash.map(data.value, '_id') : []
}

const headers = computed(() => {
  const header1 = [
    {
      field: 'code',
      headerName: $t('labels.code'),
      sortable: true,
      filter: 'agTextColumnFilter'
    },
    {
      field: 'journeyName',
      headerName: $t('labels.journey2')
    }
  ]

  const header2 = () => {
    if (transportation.value === 'CONTAINER') {
      return {
        field: 'orderData.contCategoryName',
        headerName: $t('labels.containerType'),
        sortable: true,
        filter: 'agTextColumnFilter',
        valueGetter: (params: any) => {
          const orderData = params.data.orderData
          return getTypeCategoryName(orderData) || ''
        }
      }
    }

    if (transportation.value === 'NON_CONTAINER') {
      return {
        field: 'orderData.weightCommodity',
        headerName: $t('labels.weightCommodityByKG'),
        sortable: true,
        filter: 'agTextColumnFilter',
        valueGetter: (params: any) => {
          const weightCommodity = params.data?.orderData?.weightCommodity
          return weightCommodity ? $formatters.formatNumber(weightCommodity) : ''
        }
      }
    }
  }

  const header3 = [
    {
      field: 'timeOut',
      headerName: 'Bắt đầu chặng',
      valueGetter: (params: any) => {
        const timeIn = params.data?.timeIn
        return timeIn ? $formatters.datetime(timeIn, 'DD/MM/YYYY HH:mm') : ''
      }
    },
    {
      field: 'timeOut',
      headerName: 'Kết thúc chặng',
      valueGetter: (params: any) => {
        const timeOut = params.data?.timeOut
        return timeOut ? $formatters.datetime(timeOut, 'DD/MM/YYYY HH:mm') : ''
      }
    }
  ]

  return [...header1, header2(), ...header3]
})

const getTypeCategoryName = (data: any) => {
  let resultString = ''

  resultString += `${data?.contCategory} feet`

  const { headContainer, mergeContainer } = data || {}

  if (headContainer || mergeContainer) {
    resultString += ' - '
    if (headContainer) {
      resultString += $t('labels.headContainer')
    }
    if (headContainer && mergeContainer) {
      resultString += ','
    }
    if (mergeContainer) {
      resultString += ' ' + $t('labels.mergeContainer')
    }
  }

  return resultString
}

const handleAction = async (action: string) => {
  const ids = itemSelected.value || []
  const api = $urlPartner.trip.journey.responseAllocation
  const data: any = await $api(api, {
    body: {
      ids,
      action,
      allocationCode: allocationCode.value
    }
  })
  const resData: any = data.data.value
  if (resData?.success) {
    if (action === 'approve') {
      process.client && $toast().success($t('labels.approveJourneySuccess'))
    } else {
      process.client && $toast().success($t('labels.rejectJourneySuccess'))
      showPopupReject.value = false
    }
    if (dataTables?.value) {
      dataTables.value.refresh()
    }
  }
}
</script>
